<div class="landing-inversores">
  <landing-inversores-header></landing-inversores-header>
  <landing-inversores-hero></landing-inversores-hero>
  <landing-inversores-trust-stats></landing-inversores-trust-stats>
  <landing-inversores-media></landing-inversores-media>
  <landing-inversores-process></landing-inversores-process>
  <landing-inversores-investment-types></landing-inversores-investment-types>
  <landing-inversores-value-props></landing-inversores-value-props>
  <landing-inversores-testimonials></landing-inversores-testimonials>
  <landing-inversores-value-services></landing-inversores-value-services>
  <landing-inversores-faq></landing-inversores-faq>
  <landing-inversores-final-cta></landing-inversores-final-cta>
  <landing-inversores-footer></landing-inversores-footer>
</div>
